import {ScopedCssBaseline, ThemeProvider} from "@mui/material";
import {SurveyTheme} from "crqlar-react-common/dist/models/survey/survey.model";
import React, {useMemo} from "react";
import {useFont} from "../../common/newFontPicker/fonts";
import {surveyFontOf} from "./surveyFont";
import {surveyThemeToMuiTheme} from "./surveyRunnerTheme";
import {surveyControls} from "./surveyRunnerColors";

interface Props {
    theme?: SurveyTheme
    children: React.ReactNode
}

function SurveyRunnerThemeProvider({theme, children}: Props) {
    const muiTheme = useMemo(() => surveyThemeToMuiTheme(theme), [theme]);
    const font = surveyFontOf(theme);
    // The editor preview, the create dialog's preview and the guest page all load the font here
    useFont(font.fontSource, font.fontUrl, font.fontFamily);

    const controls = surveyControls(muiTheme);

    return (
        <ThemeProvider theme={muiTheme}>
            <ScopedCssBaseline
                sx={{
                    bgcolor: 'background.default',
                    colorScheme: muiTheme.palette.mode,
                    caretColor: 'text.primary',
                    '& ::selection': {backgroundColor: 'primary.main', color: 'primary.contrastText'},
                    '& a': {color: controls.accent, textUnderlineOffset: '3px'},
                    '& button:focus-visible': {
                        outline: `2px solid ${controls.focus}`,
                        outlineOffset: 3,
                    },
                    color: 'text.primary',
                    minHeight: '100%',
                    flex: '1 0 auto',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {children}
            </ScopedCssBaseline>
        </ThemeProvider>
    );
}

export default SurveyRunnerThemeProvider;
